"use strict";

define('evisions/helper/test',['underscore', 'modernizr'], function (_) {
  var EVIHelperTest = _.extend({
    isARMDevice: function isARMDevice() {
      try {
        return navigator.userAgent.toLowerCase().search('arm') > 1;
      } catch (e) {}
      return false;
    },
    isIE: function isIE() {
      var userAgent = navigator.userAgent.toLowerCase(),
        valid = userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1;
      return valid && parseInt(userAgent.split('msie')[1]);
    },
    isArray: function isArray() {
      return _.isArray.apply(_, arguments);
    },
    isObject: function isObject() {
      return _.isObject.appy(_, arguments);
    },
    isFunction: function isFunction() {
      return _.isFunction.apply(_, arguments);
    },
    isJSON: function isJSON(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    isMacDesktop: function isMacDesktop() {
      if (navigator !== undefined) {
        return navigator.appVersion.indexOf("Mac") !== -1;
      }
      return false;
    },
    isNaN: function isNaN() {
      return _.isNaN.apply(_, arguments);
    },
    isSecure: function isSecure() {
      return window.location.protocol === 'https:';
    },
    isTabletDevice: function isTabletDevice() {
      return this.isTouchDevice() || this.isARMDevice();
    },
    isTouchDevice: function isTouchDevice() {
      return !Modernizr.touch ? false : true;
    },
    makeFunction: function makeFunction(cb) {
      return this.isFunction(cb) ? cb : function () {};
    }
  });
  return EVIHelperTest;
});

